import { useQuery } from '@tanstack/react-query';
import { Device } from '@ixicare/resources';
import React from 'react';
import { useStores } from '~store/utils';

export function useLowBatteryDevices() {
  const { auth } = useStores();
  const { data, refetch } = useQuery({
    queryKey: ['low-battery-devices'],
    queryFn: () =>
      Device.getLowBatteryDevices({
        site: auth.user!.site!.uuid,
        threshold: 26,
      }),
    enabled: !!auth.user?.site?.uuid,
  });
  const isFocused = true;
  React.useEffect(() => {
    if (isFocused) {
      refetch();
    }
  }, [isFocused]);
  return data;
}
